// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"SocialLinks__socialLinks","iconContainer":"SocialLinks__iconContainer"};